import { render, staticRenderFns } from "./TransPort.vue?vue&type=template&id=0f761670&scoped=true"
import script from "./TransPort.vue?vue&type=script&lang=js"
export * from "./TransPort.vue?vue&type=script&lang=js"
import style0 from "./TransPort.vue?vue&type=style&index=0&id=0f761670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f761670",
  null
  
)

export default component.exports